import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/audiolab/soundkits/$SOUNDKIT_ID")({
  component: RouteComponent,
  head: () => ({ meta: [{ title: "Sound Kit | Audiolab | Lutely" }] }),
});

function RouteComponent() {
  return <div>Hello "/audiolab/soundkits/2SOUNDKIT_ID"!</div>;
}
